module.exports = __webpack_public_path__ + "static/AvenirLTProHeavy-0355f8cbf2bb39bd13ab6285b97cfdc2.woff";